<template>
    <div>
        <div class="search">
            <a-form-model layout="inline" :model="searchForm">
                <a-form-model-item label="课程名称">
                    <a-input :maxLength="30" class="serach-item" v-model="searchForm.organizationCourseName"
                             placeholder="请输入"/>
                </a-form-model-item>
                <a-form-model-item>
                    <a-button @click="getPageList(1)" type="primary" html-type="button">
                        查询
                    </a-button>
                    <a-button @click="searchReset" style="margin-left: 10px;">
                        重置
                    </a-button>
                </a-form-model-item>
            </a-form-model>
        </div>
        <a-table style="min-width: 800px;"
                 :columns="columns"

                 :rowKey="record=> JSON.stringify(record)"
                 :pagination="tableRelevant.tablePagination"
                 :scroll="{y: 300}"
                 :row-selection="rowSelection"
                 :loading="tableRelevant.tableLoading"
                 :locale="tableRelevant.locale"
                 :dataSource="tableRelevant.tableDataSource">
            <span slot="progress" slot-scope="text, record">
                <a-progress :percent="text" size="small"/>
            </span>
        </a-table>
    </div>
</template>

<script>
    import {tableRelevant} from "@/pages/projectImpl/js/utils";

    const columns = [
        {
            title: '课程名称',
            dataIndex: 'organizationCourseName',
            ellipsis: true
        },
        {
            title: '进行状态',
            dataIndex: 'progress',
            scopedSlots: {customRender: 'progress'}
        },
        {
            title: '创建时间',
            dataIndex: 'createTime'
        }
    ];
    export default {
        name: "StepsSecondAddCourse",
        props: {
            collapseList: Array
        },
        data() {
            return {
                columns,
                //当前报告信息
                reportInfo: this.$store.getters['organization/getReportInfo'],
                searchForm: {
                    organizationCourseName: undefined,
                    enabled: undefined
                },
                //表格相关
                tableRelevant: tableRelevant.call(this),
                //表格选中项
                tableSelected: {
                    selectedRowKeys: [],
                    selectedRows: []
                }
            }
        },
        computed: {
            rowSelection() {
                return {
                    selectedRowKeys: this.tableSelected.selectedRowKeys,
                    onChange: (selectedRowKeys, selectedRows) => {
                        this.tableSelected.selectedRowKeys = selectedRowKeys;
                        console.log(this.tableSelected.selectedRowKeys)
                        this.tableSelected.selectedRows = selectedRows;
                    },
                    getCheckboxProps: record => ({
                        props: {
                            disabled: record.isSelect
                        },
                    }),
                };
            }
        },
        mounted() {
            this.getPageList();
            // this.initTableSelectedRowKeys();
        },
        methods: {
            //获取课时列表
            getPageList(pageIndex) {
                const params = {
                    pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
                    pageSize: this.tableRelevant.tablePagination.pageSize,
                    organizationId:this.reportInfo.organizationId,
                    reportConfigId:this.reportInfo.id,
                    ...this.searchForm
                };
                this.tableRelevant.tableLoading = true;
                this.$http.GroupReport.GetPersonalCombinationReportCoursePageList(params).then(res => {
                    this.tableRelevant.tableDataSource = res.data.items;
                    this.tableRelevant.tablePagination.total = res.data.totalCount;
                    this.tableRelevant.tablePagination.current = res.data.pageIndex;
                    this.tableRelevant.tableDataSource.map(v=>{
                        if(v.isSelect){
                            this.tableSelected.selectedRowKeys.push(JSON.stringify(v))
                            // this.tableSelected.selectedRows.push(v)
                        }
                    })
                }).finally(() => {
                  this.tableRelevant.tableLoading = false;
                })
            },

            //重置
            searchReset() {
                this.searchForm = {
                    organizationCourseName: ""
                };
                this.getPageList(1);
            },
        }
    }
</script>

<style scoped>
    .serach-item {
        width: 180px;
        margin-bottom: 15px;
    }
</style>
